import React from "react";
import { motion } from "framer-motion";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const YG_LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_bright-installations-1/artifacts/poi36fgm_younggunslighting%20logo.png";
const OMNI_BADGE = "https://customer-assets-v7afamib.emergentagent.net/job_bright-installations-1/artifacts/b35qdpuq_Omni%20Certified%20Installer%20Logo%20%281%29.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid={FOOTER.root} className="relative border-t border-white/10 bg-[#05070A] overflow-hidden">
      <div className="container-x pt-24 pb-10">
        <div className="grid lg:grid-cols-[2fr_1fr_1fr_1fr] gap-10 md:gap-14 mb-16">
          <div>
            <img
              src={YG_LOGO}
              alt="Young Guns Lighting Solutions"
              className="h-72 md:h-96 w-auto object-contain drop-shadow-[0_0_60px_rgba(0,229,255,0.55)]"
            />
            <p className="mt-6 text-white/60 max-w-sm text-sm leading-relaxed">
              Permanent architectural lighting and Omni RGB installations for homes and businesses across Wisconsin and Southwest Florida. Light it once. Enjoy it forever.
            </p>
            <div className="mt-6 flex items-center gap-4">
              {[Instagram, Facebook, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-white/10 text-white/60 hover:text-[color:var(--primary)] hover:border-[color:var(--primary)] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Studio</div>
            <address className="not-italic text-white/80 text-sm leading-relaxed space-y-1">
              <div>420 Golden Ave</div>
              <div>Wisconsin Dells, WI</div>
              <a href="tel:+16085470711" className="block hover:text-[color:var(--primary)] transition-colors">
                608 · 547 · 0711
              </a>
              <a href="mailto:younggunslighting@gmail.com" className="block hover:text-[color:var(--primary)] transition-colors break-all">
                younggunslighting@gmail.com
              </a>
            </address>
          </div>

          <div>
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Services</div>
            <ul className="space-y-2 text-white/80 text-sm">
              <li>Omni RGB Lights</li>
              <li>Permanent Home Lighting</li>
              <li>Commercial Installations</li>
              <li>Holiday Lighting</li>
              <li>Yard & Landscape</li>
              <li>Maintenance Contracts</li>
            </ul>
          </div>

          <div>
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Certified</div>
            <div className="inline-flex items-center gap-3 border border-white/10 p-3 bg-[#0C1017]">
              <div className="rounded-full bg-white p-1">
                <img src={OMNI_BADGE} alt="Omni RGB Certified Installer" className="h-9 w-9 object-contain" />
              </div>
              <div className="leading-tight">
                <div className="font-mono-accent text-[9px] tracking-[0.25em] uppercase text-white/50">Omni RGB</div>
                <div className="font-display uppercase text-white text-sm tracking-wider">Certified</div>
              </div>
            </div>
          </div>
        </div>

        {/* Massive typographic footer */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="border-t border-white/10 pt-10"
        >
          <div className="font-display uppercase leading-[0.85] tracking-tight text-white text-[clamp(3.5rem,15vw,14rem)] whitespace-nowrap overflow-hidden">
            Young<span className="text-[color:var(--primary)]"> · </span>Guns
          </div>
          <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-white/40 text-xs font-mono-accent tracking-[0.25em] uppercase">
            <span>© {year} Young Guns Lighting Solutions</span>
            <span>Wisconsin Dells · Made for the night</span>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}
